// import { Avatar, Button, Dropdown } from "antd";
// import { DownOutlined } from "@ant-design/icons";
// import React from "react";
// import { useState, useEffect } from "react";
// import { ReactComponent as NotificationIcon } from "../../../../assets/svgs/notification.svg";
// import { ReactComponent as Profile } from "../../../../assets/svgs/profile.svg";
// import { ReactComponent as Logout } from "../../../../assets/svgs/logout.svg";
// import { Link, useNavigate } from "react-router-dom";
// import { useSelector, useDispatch } from "react-redux";
// import { logout } from "../../../../redux/auth/authSlice";
// import NotificationList from "../../../../components/Elements/DialogBox/NotificationDialogBox";
// const mockUnseenNotificationCount = () => {
//   return Math.floor(Math.random() * 10);
// };

// const EmployeeHeader = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const { user } = useSelector((state) => state.auth);
//   const [unSeenNotification, setUnSeenNotification] = useState(0);
//   const [showNotifications, setShowNotifications] = useState(false);

//   useEffect(() => {
//     const fetchNotifications = () => {
//       const count = mockUnseenNotificationCount();
//       setUnSeenNotification(count);
//     };

//     fetchNotifications();
//     const intervalId = setInterval(fetchNotifications, 30000);

//     return () => clearInterval(intervalId);
//   }, []);

//   const handleLogout = () => {
//     dispatch(logout());
//     navigate("/employee/login");
//   };

//   const items = [
//     {
//       label: (
//         <Link to={"/employee/profile"}>
//           <div className="flex gap-x-2 items-center font-bold">
//             <Profile className="w-4 h-4" />
//             <span>Profile</span>
//           </div>
//         </Link>
//       ),
//       key: "0",
//     },
//     {
//       type: "divider",
//     },
//     {
//       label: (
//         <div
//           className="flex gap-x-2 items-center font-bold"
//           onClick={handleLogout}
//         >
//           <Logout className="w-4 h-4 " />
//           <span>Logout</span>
//         </div>
//       ),
//       key: "1",
//     },
//   ];

//   return (
//     <div className="flex justify-between items-center bg-white px-4 pt-4 pb-3">
//       <div className="text-xl font-semibold">Customer Name</div>

//       <div className="flex items-center  gap-x-6 ">
//         <div className="relative mt-2">
//           <Button
//             icon={<NotificationIcon className="w-16 h-16" />}
//             type="text"
//             onClick={() => setShowNotifications(true)}
//             className="relative"
//           />
//           {unSeenNotification > 0 && (
//             <div className="absolute -top-3 -right-3 translate-x-1/2 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs">
//               {unSeenNotification}
//             </div>
//           )}

//           {showNotifications && (
//             <div className="fixed top-16 right-8 z-50">
//               <NotificationList onClose={() => setShowNotifications(false)} />
//             </div>
//           )}
//         </div>
//         <Dropdown
//           placement="bottom"
//           arrow={{ pointAtCenter: true }}
//           menu={{ items }}
//           trigger={["click"]}
//         >
//           <a onClick={(e) => e.preventDefault()}>
//             <div className="flex items-center gap-x-2">
//               <Avatar
//                 size={40}
//                 style={{ background: "gray" }}
//                 src="https://api.dicebear.com/7.x/miniavs/svg?seed=1"
//               />
//               <div className="leading-tight">
//                 <div className="text-sm text-black font-semibold">
//                   {user.name}
//                 </div>
//                 <div className="text-xs text-gray-400 font-light">Admin</div>
//               </div>
//               <DownOutlined className="text-black text-sm" />
//             </div>
//           </a>
//         </Dropdown>
//       </div>
//     </div>
//   );
// };

// export default EmployeeHeader;
// Header.jsx
import { Avatar, Button, Dropdown } from "antd";
import { DownOutlined, MenuOutlined } from "@ant-design/icons";
import React, { useState, useEffect } from "react";
import { ReactComponent as NotificationIcon } from "../../../../assets/svgs/notification.svg";
import { ReactComponent as Profile } from "../../../../assets/svgs/profile.svg";
import { ReactComponent as Logout } from "../../../../assets/svgs/logout.svg";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../../../redux/auth/authSlice";
import NotificationList from "../../../../components/Elements/DialogBox/NotificationDialogBox";
import { getApi } from "../../../../api/api_instance";
import { API_URLS } from "../../../../api/apiUrls";
import { ReactComponent as ProfileImage } from "../../../../assets/svgs/avatar_green.svg";
import {
  extractNotificationCount,
  getNotificationPrefix,
} from "../../../../utils/notificationHelpers";

const Header = ({ onMenuToggle, isMobile }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user, employeeLogin, organisationLogin } = useSelector(
    (state) => state.auth,
  );

  const organizationName =
    user?.organizationName ||
    user?.client_id?.organization?.name ||
    user?.client_id?.name ||
    "";
  const [unSeenNotification, setUnSeenNotification] = useState(0);
  const [showNotifications, setShowNotifications] = useState(false);
  const [role, setRole] = useState("");
  const notificationPrefix = getNotificationPrefix({
    employeeLogin,
    organisationLogin,
  });

  const fetchNotifications = async () => {
    try {
      const response = await getApi({
        apiUrl: API_URLS.NOTIFICATIONS_UNREAD_COUNT(notificationPrefix),
      });
      setUnSeenNotification(extractNotificationCount(response));
    } catch (error) {
      console.error("Failed to fetch unread notification count:", error);
    }
  };

  useEffect(() => {
    fetchNotifications();
    const intervalId = setInterval(fetchNotifications, 30000);
    return () => clearInterval(intervalId);
  }, [notificationPrefix]);

  const handleLogout = () => {
    const savedOrgId = localStorage.getItem("orgId");
    dispatch(logout());
    navigate(`/employee/login/${savedOrgId}`);
  };

  const items = [
    {
      label: (
        <Link to={"/employee/profile"}>
          <div className="flex gap-x-2 items-center font-bold">
            <Avatar className="w-4 h-4" />
            <span>Profile</span>
          </div>
        </Link>
      ),
      key: "0",
    },
    { type: "divider" },
    {
      label: (
        <div
          className="flex gap-x-2 items-center font-bold"
          onClick={handleLogout}
        >
          <Logout className="w-4 h-4" />
          <span>Logout</span>
        </div>
      ),
      key: "1",
    },
  ];

  return (
    <div className="w-full flex flex-row justify-between items-center bg-white px-3 sm:px-4 py-1 border-b border-gray-200">
      {/* Left Side - Menu button (mobile) + User name */}
      <div className="flex items-center gap-x-3">
        {/* Mobile Menu Toggle */}
        {isMobile && (
          <Button
            type="text"
            icon={<MenuOutlined className="w-5 h-5" />}
            onClick={onMenuToggle}
            className="!p-1 flex items-center justify-center"
          />
        )}

        {/* User Name */}
        <div className=" sm:text-xs lg:text-base font-semibold truncate max-w-[120px] sm:max-w-[200px] lg:max-w-none">
          {organizationName}
        </div>
      </div>

      {/* Right Side - Notifications + User Dropdown */}
      <div className="flex items-center gap-x-3 sm:gap-x-4">
        {/* Notification Icon */}
        <div className="relative">
          <Button
            icon={
              <NotificationIcon className="w-5 h-5 sm:w-10 sm:h-10 text-gray-600 group-hover:text-blue-600 transition-colors" />
            }
            type="text"
            onClick={() => setShowNotifications(true)}
            className="!p-2 sm:!p-2.5 flex items-center justify-center hover:bg-blue-50 rounded-lg transition-all duration-200 group  hover:border-blue-200"
          />
          {unSeenNotification > 0 && (
            <div className="absolute -top-1 -right-1 bg-gradient-to-r from-red-500 to-red-600 text-white rounded-full w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center text-[8px] sm:text-[10px] font-bold shadow-sm">
              {unSeenNotification > 9 ? "9+" : unSeenNotification}
            </div>
          )}

          {showNotifications && (
            <NotificationList onClose={() => setShowNotifications(false)} />
          )}
        </div>

        {/* User Dropdown */}
        <Dropdown
          placement="bottomRight"
          arrow={{ pointAtCenter: true }}
          menu={{ items }}
          trigger={["click"]}
        >
          <a onClick={(e) => e.preventDefault()}>
            <div className="flex items-center gap-x-2 cursor-pointer p-1.5 hover:bg-gray-50 rounded-lg transition-all duration-200 group">
              <div className="relative flex items-center justify-center">
                <div
                  className={
                    isMobile
                      ? "w-8 h-8 rounded-full overflow-hidden shadow-sm flex-shrink-0 bg-[#1F5A40]"
                      : "w-10 h-10 rounded-full overflow-hidden shadow-sm flex-shrink-0 bg-[#1F5A40]"
                  }
                >
                  <ProfileImage className="w-full h-full" />
                </div>
                <div className="absolute -bottom-0.5 -right-0.5 w-3 h-3 bg-green-400 border-2 border-white rounded-full"></div>
              </div>

              {/* User Info - Hidden on very small screens */}
              <div className="hidden sm:flex flex-col leading-tight max-w-[100px] lg:max-w-[120px]">
                <span className="text-sm font-semibold text-gray-800 truncate group-hover:text-gray-900">
                  {user?.name}
                </span>
                <span className="text-xs text-[#195D39] font-medium truncate">
                  {user?.subAdmin?.isSubAdmin === true
                    ? "Sub Admin"
                    : user?.managementView?.isManagementView === true
                      ? "Management View"
                      : ""}
                  {/* : `${Array.isArray(user?.role) ? user.role.length : 0} Active Roles`} */}
                </span>
              </div>

              <DownOutlined className="text-gray-400 text-xs sm:text-sm group-hover:text-gray-600 transition-colors" />
            </div>
          </a>
        </Dropdown>
      </div>
    </div>
  );
};

export default Header;
